import React from 'react';
import useTranslation from 'next-translate/useTranslation';

// Routes
import {
    ACCOUNT,
    PLATFORM_OPTIONS,
    THEMES,
    SECURITY,
    SUBSCRIPTION_INVOICES,
    DATA_ACCESS,
    INTEGRATIONS
} from '@/routes/privateRoutes';

// Libs
import { BILLING, DATA_ACCESS as DATA_ACCESS_RIGHT } from '@/lib/acl/aclRightsList';

// Components
import LayoutLogged from '@/components/layouts/LayoutLogged';
import H2 from '@/components/base/Headings/H2';
import NavigationTabs from '@/components/base/NavigationTabs';

const HeaderSettings = ({
    current = PLATFORM_OPTIONS
}: {
    current:
        | typeof PLATFORM_OPTIONS
        | typeof ACCOUNT
        | typeof THEMES
        | typeof SECURITY
        | typeof SUBSCRIPTION_INVOICES
        | typeof DATA_ACCESS
        | typeof INTEGRATIONS; // Add typeof INTEGRATIONS here
}) => {
    const { t } = useTranslation('settings');

    const settingsTabs = [
        { label: 'settings:account', value: ACCOUNT, current: current === ACCOUNT },
        {
            label: 'settings:data_access',
            value: DATA_ACCESS,
            current: current === DATA_ACCESS,
            acl: { permissions: [DATA_ACCESS_RIGHT.read] }
        },
        {
            label: 'settings:platform',
            value: PLATFORM_OPTIONS,
            current: current === PLATFORM_OPTIONS
        },
        { label: 'settings:themes', value: THEMES, current: current === THEMES },
        { label: 'settings:security', value: SECURITY, current: current === SECURITY },
        {
            label: 'settings:integrations',
            value: INTEGRATIONS,
            current: current === INTEGRATIONS, // Update the comparison here
            acl: {
                roles: ['admin'] //remove access to subscription invoices for non-admin users
            }
        },
        {
            label: 'settings:subscription_invoices',
            value: SUBSCRIPTION_INVOICES,
            current: current === SUBSCRIPTION_INVOICES,
            acl: {
                permissions: [BILLING.read],
                roles: ['admin'] //remove access to subscription invoices for non-admin users
            }
        }
    ];

    return (
        <>
            <LayoutLogged.Header className="flex items-center space-x-1.5 sm:space-x-2.5 md:space-x-4 lg:space-x-12">
                <H2>{t('settings')}</H2>
            </LayoutLogged.Header>
            <NavigationTabs tabs={settingsTabs} />
        </>
    );
};

export default HeaderSettings;
